import {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';

import queryString from 'query-string';

import {helper, redirect, route, url} from './common/common';

const styles = (theme) => {
    return {
    };
}

class Home extends Component {
    constructor(props) {
        super(props);

        if (this.props.getAccessCode()) {
            route(this, '/organization-select-silent', '');
        } else {
            const params = helper.sanitizeDict(
                queryString.parse(this.props.location.search), 'user');

            redirect(url.login({}, params['user']));
        }
    }

    render = () => {
        return null;
    }
}

Home.propTypes = {
    setError: PropTypes.func.isRequired,
    getAccessCode: PropTypes.func.isRequired,
}

export default withStyles(styles)(Home);
